
import React from 'react';
import { CheckCircle } from 'lucide-react';

const PlanFeatures: React.FC = () => {
  return (
    <div>
      <h4 className="text-sm font-medium mb-3">Përfitimet e sistemit të kreditëve:</h4>
      <ul className="space-y-2">
        <li className="flex items-start text-sm">
          <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
          <span>25 shpallje falas pas regjistrimit, të vlefshme për një muaj dhe rinovohen automatikisht çdo muaj.</span>
        </li>
        <li className="flex items-start text-sm">
          <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
          <span>Blerja e krediteve shtesë për 49 cent për shpallje</span>
        </li>
        <li className="flex items-start text-sm">
          <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
          <span>Pa kufizime në numrin e kreditëve që mund të blini</span>
        </li>
      </ul>
    </div>
  );
};

export default PlanFeatures;
